export const BRAND_BP = 'BP'
export const BRAND_ARAL = 'Aral'

export default {
  BRAND_BP,
  BRAND_ARAL
}
